import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=2c05ba8f&scoped=true&"
import script from "./Choices.vue?vue&type=script&lang=js&"
export * from "./Choices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05ba8f",
  null
  
)

export default component.exports